/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Practice_Session_Chat_TypingInputs */



/**
* | output |
* | --- |
* | "{name} is typing" |
*
* @param {Practice_Session_Chat_TypingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_chat_typing = /** @type {((inputs: Practice_Session_Chat_TypingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Chat_TypingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.name} typt`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} écrit`)
	return /** @type {LocalizedString} */ (`${i?.name} is typing`)
});